import { UserRole } from "tm-shared/types";

import { isFieldWorkerRole, isManagerRole } from "@/utils/business";

export interface UnscheduledPointCompletionCapabilities {
    canReloadConnectedAgentSchedule: boolean;
    canLoadPlansAndFacts: boolean;
    canUseOwnRouteId: boolean;
}

export const getUnscheduledPointCompletionCapabilities = (
    role: UserRole,
): UnscheduledPointCompletionCapabilities => ({
    canReloadConnectedAgentSchedule: isManagerRole(role),
    canLoadPlansAndFacts: isFieldWorkerRole(role),
    canUseOwnRouteId: role === UserRole.Ta,
});
